import React, {Component} from 'react';
import {message, Input, Icon, Button} from 'antd';
import './login.less';
import aes from '../../../api/aes/public';
import common from '../../../utils/common.js';

const LOGIN_ROUTES = {
  cmsActivationCode: '/cms/activationCode',
  msActivationCode: '/ms/activationCode',
  cmsHome: '/main',
  msHome: '/',
  productList: '/searchDetail',
  orderList: '/orderList',
  payment: '/successfulPayment'
};

const toStorageValue = value => (value === undefined || value === null ? '' : value);

function normalizeIdentity(value) {
  if (value === 0 || value === '0') return 0;
  if (value === 1 || value === '1') return 1;
  return null;
}

function saveLoginSession(res, identity, sourceCMS, labelType) {
  const headParams = {
    login_name: res.login_name,
    partner_id: res.partner_id
  };
  const session = {
    fullName: toStorageValue(res.full_name),
    level: toStorageValue(res.stock_level_id),
    PKEY: toStorageValue(res.partner_key),
    identity: toStorageValue(identity),
    headParams: JSON.stringify(headParams),
    sourceCMS,
    platformCode: toStorageValue(''), // 平台编码（默认 EW_N8636137588）
    agentNo: toStorageValue(''), // 代理商编码（默认 EW_N7021704446）
    lableType: labelType
  };

  Object.keys(session).forEach(key => {
    window.localStorage.setItem(key, session[key]);
  });
}

function getPostLoginLocation(identity, sourceCMS, labelType) {
  const isCms = identity === 0;
  const isEmbeddedCms = sourceCMS === '1' && isCms;

  if (isEmbeddedCms && labelType === '1') {
    return {
      pathname: LOGIN_ROUTES.productList,
      state: {type: 'property', id: 3}
    };
  }
  if (isEmbeddedCms && labelType === '2') {
    return {pathname: LOGIN_ROUTES.orderList};
  }
  if (labelType === '3') {
    return {pathname: isCms ? LOGIN_ROUTES.cmsActivationCode : LOGIN_ROUTES.msActivationCode};
  }
  return {pathname: isCms ? LOGIN_ROUTES.cmsHome : LOGIN_ROUTES.msHome};
}


class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '', // dlsy_test128 ptdls1 jrpt 登录名
      userPwd: '', // 登录密码
      authCode: '', // 显示的验证码
      txtCode: '', // 输入的验证码
    };
  }

  //组件刚经历constructor,初始完数据,未渲染,dom还未渲染
  componentWillMount() {
    this.getKey();
    this.setState({authCode: window.common.createCode()});
  }

  //组件渲染完成
  componentDidMount() {
    //注册keydown事件
    document.addEventListener('keydown', this.onKeyDown);
  }

  //组件销毁
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  // 从其他渠道进入login，直接获取登录信息登录
  getKey = () => {
    const query = this.props.location.search;
    if (query) {
      const key = common.getQueryString(query).key;
      const res = JSON.parse(aes.Decrypt(key));
      this.loginCallback(res);
    }
  }

  // 登录后的处理
  loginCallback = (res) => {
    const identity = normalizeIdentity(res.identity);
    const sourceCMS = String(res.sourceCMS || '');
    const labelType = String(res.lableType || ''); // 3 代表联富通商城激活码 2 代表订单列表 1 代表商品列表
    const orderNo = res.order_no || '';

    saveLoginSession(res, identity, sourceCMS, labelType);

    if (orderNo) {
      this.props.history.push({
        pathname: LOGIN_ROUTES.payment,
        state: {order_no: orderNo}
      });
      return;
    }

    this.props.history.push(getPostLoginLocation(identity, sourceCMS, labelType));
  }

  // 登录
  login = () => {
    const {
      userName, userPwd, txtCode, authCode
    } = this.state;
    if (!userName) {
      message.error('请输入用户名');
      return;
    }
    if (!userPwd) {
      message.error('请输入密码');
      return;
    }
    if (!txtCode) {
      message.error('验证码不能为空，请输入验证码');
      return;
    } else if (txtCode !== authCode) {
      message.error('验证码输入不一致');
      return;
    }
    const params = {
      login_name: userName,
      login_pwd: userPwd
    };
    window.api('eps.login', params).then(res => {
      this.loginCallback(res);
    }).catch(error => {
      message.error(error.service_error_message);
    });
  }

  // 按enter键登录
  onKeyDown = (e) => {
    e.keyCode === 13 ? this.login() : null;
  }

  // 变更登录信息
  changeInfo = (type, e) => {
    let value = e.target.value;
    type === 'txtCode' ? value = value.toUpperCase() : null;
    this.setState({[type]: value});
  }

  // 刷新验证码
  refreshCode = () => {
    this.setState({authCode: window.common.createCode(), txtCode: ''});
  }

  render() {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-header">
            <h1 className="login-title">联富通商城</h1>
            <p className="login-desc">欢迎登录，请填写您的账号信息</p>
          </div>
          <div className="login-form">
            <div className="login-form-item">
              <Input
                placeholder="请输入用户名"
                size="large"
                prefix={<Icon type="user" className="login-input-icon" />}
                onChange={this.changeInfo.bind(this, 'userName')}
                value={this.state.userName}
                className="login-input"
              />
            </div>
            <div className="login-form-item">
              <Input.Password
                placeholder="请输入密码"
                size="large"
                prefix={<Icon type="lock" className="login-input-icon" />}
                onChange={this.changeInfo.bind(this, 'userPwd')}
                value={this.state.userPwd}
                className="login-input"
              />
            </div>
            <div className="login-form-item login-form-item--captcha">
              <Input
                placeholder="请输入验证码"
                size="large"
                onChange={this.changeInfo.bind(this, 'txtCode')}
                value={this.state.txtCode}
                className="login-input login-input--captcha"
              />
              <span
                className="login-captcha-code"
                onClick={this.refreshCode}
                title="点击刷新验证码"
              >
                {this.state.authCode}
              </span>
            </div>
            <div className="login-form-item login-form-item--submit">
              <Button
                type="primary"
                size="large"
                onClick={this.login}
                block
                className="login-btn"
              >
                登录
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Login;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/login/login.jsx